import { css } from "styled-system/css";
import { flex } from "styled-system/patterns";

import { Skeleton } from "../skeleton";

export const DesktopSkeletonControls = () => (
  <div className={flex({ align: "center", gap: "24" })}>
    <div className={flex({ align: "center", gap: "8" })}>
      <Skeleton className={css({ w: "[93px]", h: "32", rounded: "300" })} />
      <Skeleton className={css({ w: "[74px]", h: "32", rounded: "300" })} />
      <Skeleton className={css({ w: "20", h: "32", rounded: "300" })} />
    </div>
    <Skeleton className={css({ w: "192", h: "32", rounded: "300" })} />
  </div>
);

export const MobileSkeletonControls = () => (
  <div className={flex({ flex: "1", align: "center", justify: "space-between", gap: "8" })}>
    <Skeleton className={css({ w: "128", h: "40", rounded: "300" })} />
    <div className={flex({ align: "center", gap: "8" })}>
      <Skeleton className={css({ w: "[95px]", h: "40", rounded: "300" })} />
      <Skeleton className={css({ w: "[73px]", h: "40", rounded: "300" })} />
      <Skeleton className={css({ w: "20", h: "40", rounded: "300", hideBelow: "sm" })} />
    </div>
  </div>
);
